//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockTextAndMediaImageInputItem } from './WebsiteBlockTextAndMediaImageInputItem';
import { WebsiteBlockTextAndMediaActionUpdateItem } from './WebsiteBlockTextAndMediaActionUpdateItem';
import { WebsiteBlockUpdateItem } from './WebsiteBlockUpdateItem';
import { IWebsiteBlockInputItemHasImages } from './IWebsiteBlockInputItemHasImages';
import { WebsiteBlockTextAndMediaType, WebsiteBlockType } from './Enums';

export class WebsiteBlockTextAndMediaUpdateItem extends WebsiteBlockUpdateItem implements IWebsiteBlockInputItemHasImages {
    Header: string | null = null;
    Body: string | null = null;
    Images: WebsiteBlockTextAndMediaImageInputItem[] = [];
    Action: WebsiteBlockTextAndMediaActionUpdateItem | null = null;
    TextAndMediaType: WebsiteBlockTextAndMediaType = WebsiteBlockTextAndMediaType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.TextAndMedia;

    constructor(initializer?: Partial<Omit<WebsiteBlockTextAndMediaUpdateItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockTextAndMediaUpdateItem";
}
